































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import WorkOrderListView from '@/components/orders/WorkOrderListView.vue';
import CreateCustomFilterComponent from '@/components/orders/CreateCustomFilterComponent.vue';

import {
  PerformoSettings,
  QueryWorkOrdersRequest,
  ReportsApi,
  Workorder,
  WorkorderPagedCollectionApiResponse,
  WorkordersApi
} from 'performo-api';

import { User } from 'oidc-client';
import { mapGetters } from 'vuex';
import { SortChangedEvent } from '@/models/SortChangedEvent';

@Component({
  components: {
    WorkOrderListView,
    CreateCustomFilterComponent
  },
  computed: mapGetters({
    settings: 'settings',
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    reportsApi: 'reportsApi',
    workordersApi: 'ordersApi'
  })
})
export default class OrderList extends Vue {
  /*
  For more info on how the Work Order List Query functionality works, see below:
  Wiki page - https://dev.azure.com/wizardsoftware/Performo.Api/_wiki/wikis/Performo.Api.wiki/87/Work-Order-List-Query-Design-v2
  Related work item(s) - https://dev.azure.com/wizardsoftware/Performo.Api/_workitems/edit/1551
  */

  private currentPropertyId!: string;
  private currentUser!: User;

  private settings!: PerformoSettings;

  private pagedOrders!: WorkorderPagedCollectionApiResponse;

  private reportsApi!: ReportsApi;

  private workordersApi!: WorkordersApi;

  private startDateRange: Date[] = [];

  private completionDateRange: Date[] = [];

  private orderSetFilterChecked!: boolean;

  private allEntitiesFilterChecked!: boolean;

  private showList = true;

  private showModal = false;

  private spreadsheetDownloading = false;

  private fullListPrinting = false;

  get floorLabel() {
    return this.$store.getters.currentProperty.floorLabel
      ? this.$store.getters.currentProperty.floorLabel
      : 'Floor';
  }

  private orderClickedHandler(order: Workorder) {
    if (order.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: order.workorderId }
      });
    }
  }

  data() {
    return {
      orderSetFilterChecked: undefined,
      allEntitiesFilterChecked: undefined,
      showList: undefined,
      showModal: false
    };
  }

  mounted() {
    if (Object.keys(this.$route.query).length === 0) {
      this.handleFilterReset();
    }
  }

  @Watch('startDateRange')
  private startDateRangeChanged(dates: Date[]) {
    if (dates) {
      this.queryStartDateStart = dates[0];
      this.queryStartDateEnd = dates[1];
    } else {
      this.queryStartDateStart = undefined;
      this.queryStartDateEnd = undefined;
    }
  }

  @Watch('completionDateRange')
  private completionDateRangeChanged(dates: Date[]) {
    if (dates) {
      this.queryCompletionDateStart = dates[0];
      this.queryCompletionDateEnd = dates[1];
    } else {
      this.queryCompletionDateStart = undefined;
      this.queryCompletionDateEnd = undefined;
    }
  }

  private handleFilterReset() {
    this.orderSetFilterChecked = false;
    this.allEntitiesFilterChecked = false;
    this.$router
      .replace({
        query: {
          orderStatus: 'Open',
          sortColumn: 'orderNumber',
          sortDirection: 'descend',
          propertyId: this.currentPropertyId
        }
      })
      .catch(() => {
        /*no errors*/
      });
  }

  private resetSkip() {
    this.querySkip = 1;
  }

  @Watch('orderSetFilterChecked')
  private setCheckboxChanged() {
    if (this.orderSetFilterChecked) {
      // only display orders with a setId value
      this.querySetId = '*';
    } else {
      this.querySetId = '';
    }
  }

  @Watch('allEntitiesFilterChecked')
  private allEntitiesCheckboxChanged() {
    if (this.allEntitiesFilterChecked) {
      this.queryPropertyId = 'All';
    } else {
      this.queryPropertyId = this.currentPropertyId;
    }
  }

  private sortChangedHandler(sort: SortChangedEvent) {
    this.querySortColumn = sort.column;
    this.querySortDirection = sort.direction === 1 ? 'ascend' : 'descend';

    this.resetSkip();
  }

  private paginationSkipUpdatedHandler(skip: number) {
    this.querySkip = skip;
  }

  private updatedPagedOrders(ord: WorkorderPagedCollectionApiResponse) {
    this.pagedOrders = ord;
  }

  private updateShowList(val: boolean) {
    this.showList = val;
  }

  @Watch('currentPropertyId')
  private async propertyChanged(value: string) {
    // update the propertyId in the route query.
    this.queryPropertyId = value;

    // changing propertyId on if in detail mode, means the order
    // cannot be part of this list, so we remove it from the route query.
    let query = Object.assign({}, this.$route.query);
    delete query.orderId;
    await this.$router.replace({ query }).catch(() => {
      /* skip duplicate nav errors */
    });
  }

  private async addMasterDetailOrderIdToRoute(orderId: string) {
    if (this.$route.query.orderId) {
      await this.$router
        .replace({
          path: this.$route.fullPath,
          query: { orderId: orderId }
        })
        .catch(() => {
          //
        });
    } else {
      // preserve found set view for user to navigate back to
      await this.$router
        .push({
          path: this.$route.fullPath,
          query: { orderId: orderId }
        })
        .catch(() => {
          //
        });
    }
  }

  private get queryOrderNumber(): string {
    return this.$route.query['orderNumber'] as string | '';
  }
  private set queryOrderNumber(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          orderNumber: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryOrderCategory(): string {
    return this.$route.query['orderCategory'] as string | '';
  }
  private set queryOrderCategory(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          orderCategory: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryTrade(): string {
    return this.$route.query['trade'] as string | '';
  }
  private set queryTrade(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          trade: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryJobType(): string {
    return this.$route.query['jobType'] as string | '';
  }
  private set queryJobType(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          jobType: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryPriority(): string {
    return this.$route.query['jobPriority'] as string | '';
  }
  private set queryPriority(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          jobPriority: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryAssignTo(): string {
    return this.$route.query['assignTo'] as string | '';
  }
  private set queryAssignTo(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          assignTo: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryStartDateStart(): Date | undefined {
    return new Date(this.$route.query['startDateStart'] as string);
  }
  private set queryStartDateStart(value: Date | undefined) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          startDateStart: value ? value.toString() : undefined,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryStartDateEnd(): Date | undefined {
    return new Date(this.$route.query['startDateEnd'] as string);
  }
  private set queryStartDateEnd(value: Date | undefined) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          startDateEnd: value ? value.toString() : undefined,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryCompletionDateStart(): Date | undefined {
    return new Date(this.$route.query['completionDateStart'] as string);
  }
  private set queryCompletionDateStart(value: Date | undefined) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          completionDateStart: value ? value.toString() : undefined,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryCompletionDateEnd(): Date | undefined {
    return new Date(this.$route.query['completionDateEnd'] as string);
  }
  private set queryCompletionDateEnd(value: Date | undefined) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          completionDateEnd: value ? value.toString() : undefined,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryOrderByField(): string {
    return this.$route.query['orderBy'] as string | '';
  }
  private set queryOrderByField(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          orderBy: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryOrderByField2(): string {
    return this.$route.query['orderByField2'] as string | '';
  }
  private set queryOrderByField2(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          orderByField2: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryOrderDescription(): string {
    return this.$route.query['description'] as string | '';
  }
  private set queryOrderDescription(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          description: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryCampus(): string {
    return this.$route.query['campus'] as string | '';
  }
  private set queryCampus(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          campus: value,
          building: '',
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryBuilding(): string {
    return this.$route.query['building'] as string | '';
  }
  private set queryBuilding(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          building: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryFloor(): string {
    return this.$route.query['floor'] as string | '';
  }
  private set queryFloor(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          floor: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryRoom(): string {
    return this.$route.query['suite'] as string | '';
  }
  private set queryRoom(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          suite: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryOrderStatus(): string {
    return this.$route.query['orderStatus'] as string | '';
  }
  private set queryOrderStatus(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          orderStatus: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryIncludeSubStatuses(): boolean {
    return this.$route.query['includeSubStatuses'] == 'true';
  }
  private set queryIncludeSubStatuses(value: boolean) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          includeSubStatuses: value.toString(),
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get querySetId(): string {
    return this.$route.query['setId'] as string | '';
  }
  private set querySetId(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          setId: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get querySortColumn(): string {
    return this.$route.query['sortColumn'] as string | '';
  }
  private set querySortColumn(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          sortColumn: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get querySortDirection(): string {
    return this.$route.query['sortDirection'] as string | '';
  }
  private set querySortDirection(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          sortDirection: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get querySkip(): number {
    return parseInt(this.$route.query['skip'] as string) | 1;
  }
  private set querySkip(value: number) {
    this.$router
      .push({
        query: {
          ...this.$route.query,
          skip: value.toString()
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get queryPropertyId(): string {
    return (this.$route.query['propertyId'] as string)
      ? (this.$route.query['propertyId'] as string)
      : this.currentPropertyId;
  }
  private set queryPropertyId(value: string) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        propertyId: value ? value : this.currentPropertyId,
        skip: '1'
      }
    });
  }

  private get queryOrderAsset(): string {
    return this.$route.query['multiAssetDisplay'] as string | '';
  }
  private set queryOrderAsset(value: string) {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          multiAssetDisplay: value,
          skip: '1'
        }
      })
      .catch(() => {
        /* ignore-duplicate-navigation warns */
      });
  }

  private get QueryGetter(): QueryWorkOrdersRequest {
    // assign the query string parameters to the query object
    // using our default query parameters
    let queryObject = Object.assign(
      {
        orderStatus: 'Open',
        sortColumn: 'orderNumber',
        sortDirection: 'descend',
        propertyId: this.currentPropertyId
      },
      this.$route.query
    ) as QueryWorkOrdersRequest;

    // range helpers
    if (this.$route.query['startDateStart'] as string) {
      queryObject.startDateStart = new Date(
        this.$route.query['startDateStart'] as string
      );
    }
    if (this.$route.query['startDateEnd'] as string) {
      queryObject.startDateEnd = new Date(
        this.$route.query['startDateEnd'] as string
      );
    }

    if (this.$route.query['completionDateStart'] as string) {
      queryObject.completionDateStart = new Date(
        this.$route.query['completionDateStart'] as string
      );
    }
    if (this.$route.query['completionDateEnd'] as string) {
      queryObject.completionDateEnd = new Date(
        this.$route.query['completionDateEnd'] as string
      );
    }

    return queryObject;
  }

  private handlePrint(reportId: number) {
    if (this.pagedOrders.data && this.pagedOrders.data?.length > 0) {
      let foundIds = '';
      this.pagedOrders.data.forEach((element: Workorder) => {
        foundIds += '\n' + element.workorderId;
      });
      this.reportsApi
        .queueReport({
          queueReportCommand: {
            outputType: 'PDF',
            propertyId: this.currentPropertyId,
            reportName: `Work Order ${
              reportId === 1002 ? 'Batch List' : 'List'
            } Report`,
            reportId: reportId,
            foundSetIds: foundIds
          }
        })
        .then(this.printSuccess);
      // 1000 = detail
      // 1002 = list, details
      // 1004 = list, list
    }
  }

  private async handlePrintFullList() {
    if (
      !confirm(
        'This will generate a report for all work orders matching the current filters. This may take a few minutes and will automatically navigate you to the report when done. Continue?'
      )
    ) {
      return;
    }
    this.fullListPrinting = true;
    try {
      const baseQuery = this.QueryGetter;
      const pageSize = 100;
      let skip = 0;
      let foundIds = '';

      let hasMorePages = true;
      while (hasMorePages) {
        const query: QueryWorkOrdersRequest = {
          ...baseQuery,
          skip: skip,
          take: pageSize
        };
        const response = await this.workordersApi.queryWorkOrders(query);

        if (response.data) {
          response.data.forEach((element: Workorder) => {
            foundIds += '\n' + element.workorderId;
          });
        }

        const currentPage = response.pagination?.pageNumber ?? 0;
        const totalPages = response.pagination?.totalPages ?? 1;
        skip += pageSize;
        hasMorePages = currentPage < totalPages - 1;
      }

      if (foundIds.length > 0) {
        await this.reportsApi.queueReport({
          queueReportCommand: {
            outputType: 'PDF',
            propertyId: this.currentPropertyId,
            reportName: 'Work Order Full List Report',
            reportId: 1004,
            foundSetIds: foundIds
          }
        });
        await this.printSuccess();
      }
    } finally {
      this.fullListPrinting = false;
    }
  }

  private async printSuccess() {
    this.$router.push({ name: 'reports', params: {} });
  }

  private async downloadSpreadsheet() {
    this.spreadsheetDownloading = true;
    // Create a link to download the file
    const a = document.createElement('a');
    a.download = 'WorkOrders.xlsx';

    // Fetch the data, then convert it into a form possible to add to our link
    let blob = await this.workordersApi.queryWorkOrdersAsExcel(
      this.QueryGetter
    );
    const objUrl = URL.createObjectURL(blob);

    // Add the spreadsheet data to the link, then click it
    a.href = objUrl;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();

    // Clean up the data
    document.body.removeChild(a);
    URL.revokeObjectURL(objUrl);

    this.spreadsheetDownloading = false;
  }
}
